var _clipPath, _clipPath2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiology(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "radiology"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_60",
    d: "M68,3l0,62c0,1.656 -1.344,3 -3,3l-62,0c-1.656,0 -3,-1.344 -3,-3l0,-62c0,-1.656 1.344,-3 3,-3l62,0c1.656,0 3,1.344 3,3Z",
    style: {
      fill: "#fff",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 40,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    x: 15,
    y: 18,
    width: 38,
    height: 33,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.6px"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    d: "M24.126,35.519l-0,-10.634l2.3,-2.3l1.5,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    d: "M30,22l8,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M28,26l13,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    d: "M27.164,31.721l6.252,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    d: "M34,20l-0,22",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    d: "M27,29l14,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    d: "M34.482,31.721l6.354,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    d: "M25,37l-0,12",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    d: "M43,37l-0,12",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    d: "M43.877,35.519l-0,-10.634l-2.3,-2.3l-1.5,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    d: "M27.923,49.191l-0,-5.317l1.519,-1.519",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    d: "M40.076,49.191l-0,-5.317l-1.519,-1.519",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    d: "M31,35l-4,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    d: "M41,35l-4,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    d: "M32.48,39.317l-4.557,0l-0,1.519l3.038,3.038l0.76,2.279l4.557,0l0.76,-2.279l3.038,-3.038l-0,-1.519l-4.553,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 40,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    d: "M40.076,15.77l-0,-5.317l-12.153,0l-0,5.317",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    d: "M40.076,51.47l-0,6.077l-12.153,0l-0,-6.077",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiology);
export default __webpack_public_path__ + "static/media/radiology.1ed33a40371b41a3990db26084921cb5.svg";
export { ForwardRef as ReactComponent };